module.exports = __webpack_public_path__ + "img/5.d60de9dd.png";